export function FormAlert({ message }: { message: string }) {
  return (
    <div
      role="alert"
      className="rounded-xl border border-error/40 bg-error-container/30 px-4 py-3 text-body-md text-on-error-container"
    >
      {message}
    </div>
  );
}